module.exports = __webpack_public_path__ + "static/media/10.acd0a25e.jpeg";